// extracted by mini-css-extract-plugin
module.exports = {"md":"actions-menu-item_md_3Y5c8","ios":"actions-menu-item_ios_14KS4","icon":"actions-menu-item_icon_ghrEG"};